import { render } from "./WorkflowServiceData.vue?vue&type=template&id=2efb1b70&scoped=true"
import script from "./WorkflowServiceData.vue?vue&type=script&lang=js"
export * from "./WorkflowServiceData.vue?vue&type=script&lang=js"

import "./WorkflowServiceData.vue?vue&type=style&index=0&id=2efb1b70&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efb1b70"]])

export default __exports__